// src/components/AdminRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { currentUser, isAdmin } = useAuth();

  // If there's no user or the user is not an admin, redirect them
  if (!currentUser || !isAdmin) {
    alert('You do not have permission to view this page.');
    return <Navigate to="/" />;
  }

  // If the user is an admin, render the component
  return children;
};

export default AdminRoute;